module.exports = __webpack_public_path__ + "static/media/flightloader.9dbde618.gif";